export const AutoUpdate = {
  Off: 'off',
  Streaming: 'streaming',
  Periodic: 'periodic'
};
